import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import StickyGeneratorCTA from './components/StickyGeneratorCTA'
import HomePage from './pages/HomePage'
import TemplatesPage from './pages/TemplatesPage'
import InvoiceTypesPage from './pages/InvoiceTypesPage'
import IndustryPage from './pages/IndustryPage'
import BlogPage from './pages/BlogPage'
import ArticlePage from './pages/ArticlePage'
import InvoiceHistoryPage from './pages/InvoiceHistoryPage'
import PaymentSuccessPage from './pages/PaymentSuccessPage'
import AnalyticsDashboard from './pages/AnalyticsDashboard'
import ProtectedRoute from './components/ProtectedRoute'
import OnlineBillingSoftwarePage from './pages/OnlineBillingSoftwarePage'
import CanvaAlternativePage from './pages/CanvaAlternativePage'
import ShopifyInvoicePage from './pages/ShopifyInvoicePage'
import VATInvoicePage from './pages/VATInvoicePage'
import Footer from './components/Footer'

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/invoice-types/:type" element={<InvoiceTypesPage />} />
          <Route path="/industries/:industry" element={<IndustryPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />
          <Route path="/history" element={<ProtectedRoute><InvoiceHistoryPage /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><AnalyticsDashboard /></ProtectedRoute>} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/online-billing-software" element={<OnlineBillingSoftwarePage />} />
          <Route path="/canva-invoice-maker-alternative" element={<CanvaAlternativePage />} />
          <Route path="/shopify-invoice-generator" element={<ShopifyInvoicePage />} />
          <Route path="/vat-tax-invoice-template" element={<VATInvoicePage />} />
        </Routes>
        <Footer />
        <StickyGeneratorCTA />
      </div>
    </BrowserRouter>
  )
}

export default App
